import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-print",
  "use": "foquz-icon-print-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-print\"><path d=\"M4 6V1h9v5m-9 7H2.5c-.398 0-.78-.164-1.06-.456a1.585 1.585 0 01-.44-1.1V7.556c0-.413.158-.809.44-1.1A1.473 1.473 0 012.5 6h12c.398 0 .78.164 1.06.456.282.291.44.687.44 1.1v3.888c0 .413-.158.809-.44 1.1A1.474 1.474 0 0114.5 13H13m-9-3h9v6H4v-6z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol